/**
 * Copy for the General settings panel (ADR-0064).
 *
 * **The first settings screen that is nobody's administration**, which is what
 * its voice has to carry. Spaces, Users, Storage, and Audit address an admin
 * doing agency work; this one addresses whoever is reading, about their own
 * copy of the app. Sentence case, no emoji, and — the rule most easily broken on
 * a preferences screen — no persuasion. A theme is a preference, not a feature
 * being sold.
 *
 * **The switcher's options are not "Dark mode" and "Light mode".** They are the
 * two surfaces plus the deferral, and the deferral needs the longer label: on
 * its own "System" is a word about the computer, and what the reader wants to
 * know is that this choice tracks a setting they made somewhere else.
 */
export const GENERAL_COPY = {
  title: 'General',
  summary: 'How this app looks on this device.',

  theme: {
    /** Opens the section — an `<Eyebrow as="h2">`, so it is in the outline. */
    heading: 'Appearance',
    /**
     * The `<fieldset>`'s legend, and the accessible name of the group of three
     * radios inside it. Says what is being chosen, not what to do about it.
     */
    label: 'Theme',
    hint: 'Saved on this device. Signing in elsewhere will not carry it across.',

    system: 'System',
    /** The one option that needs a second line — see the note above. */
    systemHint: 'Match this device',
    light: 'Light',
    dark: 'Dark',
  },
} as const;
